module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAACCAYAAACKVvbTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVQImWP08PBQYmBguMuAG8xiwiMJBwCWwAJ1ztoV6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxsc/9-.png
// module id = Xhg0
// module chunks = 1